import { TCreateDishAction, CreateDishActionTypes } from './createDishActions';
import { ICreateDishState } from './createDishContext';

export const createDishReducer = (state: ICreateDishState, action: TCreateDishAction): ICreateDishState => {
	switch (action.type) {
		case CreateDishActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateDishActionTypes.CHANGE_NAME_OF_DISH:
			return {
				...state,
				nameOfDish: action.payload.nameOfDish,
			};
		case CreateDishActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateDishActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
				fetchedRestaurants: [],
			};
		case CreateDishActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedModificationDishCategory: null,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
				fetchedModificationDishes: [],
				selectedModificationDishes: [],
			};
		case CreateDishActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case CreateDishActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateDishActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateDishActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateDishActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case CreateDishActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateDishActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateDishActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedModificationDishCategory: null,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
				fetchedModificationDishes: [],
				selectedModificationDishes: [],
			};
		case CreateDishActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISH_CATEGORY:
			return {
				...state,
				selectedSuggestedDishCategory: action.payload.selectedSuggestedDishCategory,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedSuggestedDishSubCategories: action.payload.fetchedSuggestedDishSubCategories,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedSuggestedDishSubCategory: action.payload.selectedSuggestedDishSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISHES:
			return {
				...state,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISHES:
			return {
				...state,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY:
			return {
				...state,
				selectedAdditionalDishCategory: action.payload.selectedAdditionalDishCategory,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedAdditionalDishSubCategories: action.payload.fetchedAdditionalDishSubCategories,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedAdditionalDishSubCategory: action.payload.selectedAdditionalDishSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES:
			return {
				...state,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISHES:
			return {
				...state,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		case CreateDishActionTypes.SET_MODIFICATION_DISH_CATEGORY:
			return {
				...state,
				selectedModificationDishCategory: action.payload.selectedModificationDishCategory,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedModificationDishSubCategories: action.payload.fetchedModificationDishSubCategories,
			};
		case CreateDishActionTypes.SET_MODIFICATION_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedModificationDishSubCategory: action.payload.selectedModificationDishSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_MODIFICATION_DISHES:
			return {
				...state,
				fetchedModificationDishes: action.payload.fetchedModificationDishes,
			};
		case CreateDishActionTypes.SET_MODIFICATION_DISHES:
			return {
				...state,
				selectedModificationDishes: action.payload.selectedModificationDishes,
			};
		case CreateDishActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateDishActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				nameOfDish: '',
				description: '',
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				externalId: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				hasSchedulePriority: false,
				activationSchedule: '',
				deactivationSchedule: '',
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedModificationDishCategory: null,
				fetchedModificationDishSubCategories: [],
				selectedModificationDishSubCategory: null,
				fetchedModificationDishes: [],
				selectedModificationDishes: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
